import moment from 'moment';

export const meridiemTo24Hour = (hr, mer) => {
  if (mer === 'pm') {
    if (hr === 12) {
      return 12;
    }
    return hr + 12;
  }
  if (mer === 'am' && hr === 12) {
    return 0;
  }
  return hr;
};

export const twentyFourToMeridiem = (hr) => {
  if (hr === 0) {
    return 12;
  }
  if (hr > 12) {
    return hr - 12;
  }
  return hr;
};

export const meridiemLabelFromHour = (hr) => {
  if (hr === 24) {
    return 'am';
  }
  if (hr > 11) {
    return 'pm';
  }
  return 'am';
};

export const currentRangeDelimiter = (
  string,
  singleDatePicker,
  rangeDelimiters
) => (!singleDatePicker
  ? rangeDelimiters.find(
    (key) => string.split(key)?.length === 2
  )
  : rangeDelimiters[0]);

export const stringToDates = (string, singleDatePicker, rangeDelimiters, formats) => {
  const separator = currentRangeDelimiter(string, singleDatePicker, rangeDelimiters);
  const dateStrings = (!singleDatePicker ? string.split(separator) : [string, string]).map(
    (item) => item.trim()
  );

  if (!singleDatePicker && dateStrings.length === 1) {
    dateStrings.push(string); // make the start and end date the same in this scenario
  }

  const strictFormat = formats.length > 1;
  /* istanbul ignore next */
  const formatsList = typeof formats[0] === 'function'
    ? formats.shift().length ? formats : undefined : formats;

  return dateStrings.map((str) => moment(str, formatsList, strictFormat));
};

export const formatTime = (time, timePicker24Hour, timePickerSeconds) => {
  if (timePicker24Hour) {
    if (timePickerSeconds) return time.format('HH:mm:ss');
    return time.format('HH:mm');
  }
  if (timePickerSeconds) return time.format('h:mm:ssa');
  return time.format('h:mma');
};

export const datesToString = (date, endDate, { format, rangeDelimiter, singleDatePicker }) => {
  /** Allows the user to provide any format they want */
  if (format && typeof format === 'function') {
    return format(date, endDate);
  }
  if ((date && !date.isValid()) || (endDate && !endDate.isValid())) {
    /**
     * if date input has invalid value we should see that invalid string without formatting
     * @example input string = 'qwerty';
     */
    // eslint-disable-next-line no-underscore-dangle
    return !endDate || singleDatePicker ? `${date._i}` : `${date._i}${rangeDelimiter}${endDate._i}`;
  }

  if ((date && !endDate) || (endDate && endDate.isSame(date, 'day'))) {
    /**
     * if date has time you can use moment to format it
     * @example format = 'MM/DD/YYYY h:mmA';
     */
    return date.format(format);
  }
  if (date && endDate) {
    /** default prop for range delimiter is ' - ' */
    return `${date.format(format)}${rangeDelimiter}${endDate.format(format)}`;
  }
  return '';
};
